export const DRAG_SWIPE_TIMEOUT = 1e2;
export const DRAG_SWIPE_BOUNCE_MIN_RATE = 0.1;
export const DRAG_SWIPE_BOUNCE_MAX_DIS = 0.33;
export const FRAME_SPAN = 17;
export const DRAG_MODE = {
    ALWAYS: 'always',
    HYBRID: 'hybrid',
    NONE: 'none',
};

export const SWIPE_MODE = {
    ANIM: 'animation',
    TRANS: 'transition',
};

export const TRANSFORM_MODE = {
    TRANS_FIRST: 'translate-first',
    SCALE_FIRST: 'scale-first',
}